<template>
  <div class="contrastData">
    <div class="abnormal "><!--contrastDataForm-->
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="马帮ERP">
          <el-input style="width:200px" v-model="formInline.MaterialNumber" placeholder="SKU" clearable />
        </el-form-item>
        <el-form-item label="订单起始时间">
          <el-date-picker
              value-format="YYYY-MM"
              format="YYYY-MM"
              v-model="formInline.startMonth"
              type="month"
              placeholder="产品发货月份"
              clearable
          />
          -
          <el-date-picker
              value-format="YYYY-MM"
              format="YYYY-MM"
              v-model="formInline.endMonth"
              type="month"
              placeholder="产品发货月份"
              clearable
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="onSubmit">清除异常</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div  class="abnormals" style="font-size: 24px" >
      <div class="abnormalitem" >核对订单: <span style="color:#117EEE">{{defaultTotal}}</span> </div>
      <div class="abnormalitem">核对金额: <span style="color:#117EEE">{{moneyCount}}</span> </div>
      <div class="abnormalitem">基础运费: <span style="color:#117EEE">{{baseMoney}}</span> </div>
      <div class="abnormalitem">附加费: <span style="color:#117EEE">{{addMoney}}</span> </div>
      <div class="abnormalitem">操作费: <span style="color:#117EEE">{{optionMoney}}</span> </div>
      <el-button type="danger" @click="changeType('weight')" class="abnormalitem cursor">重量异常: <span >{{weight}}</span> </el-button>
<!--      style="color:#F905DD" style="color:#F20DB1"  -->
      <el-button type="primary" @click="changeType('area')" class="abnormalitem cursor">区域异常: <span >{{area}}</span> </el-button>
      <el-button type="warning" @click="changeType('volume')" class="abnormalitem cursor">体积异常: <span >{{volume}}</span> </el-button>
    </div>
    <div class="contrastDataTable">
      <el-table :max-height="height" :data="tableData" :preserve-expanded-content="true" :stripe="true" :border="true" :highlight-current-row="true" size="default" >
        <el-table-column style="width:100%"  type="expand">
          <template  #default="props">
            <div class="templateDiv" m="4">
              <div class="cloume_div_list">
                <div class="cloume_div_list_item cloume_div_list_item_top cloume_div_list_item_left">体积对比结果</div>
                <div class="cloume_div_list_item cloume_div_list_item_top">数据来源</div>
                <div class="cloume_div_list_item cloume_div_list_item_top">长(cm)</div>
                <div class="cloume_div_list_item cloume_div_list_item_top">宽(cm)</div>
                <div class="cloume_div_list_item cloume_div_list_item_top">高(cm)</div>
                <div class="cloume_div_list_item cloume_div_list_item_top">体积(cm³)</div>
              </div>
              <div class="cloume_div_list">
                <div style="height:40px;line-height:40px" class="cloume_div_list_item cloume_div_list_item_left"  :class="{abnormalColor:!props.row.isVolume}" >{{ props.row.isVolume ? "正常" :"存疑"}}</div>
                <div>
                  <div class="cloume_div_list_item" >魔方</div>
                  <div class="cloume_div_list_item">自有</div>
                </div>
                <div>
                  <div class="cloume_div_list_item">{{props.row.LengthCm}}</div>
                  <div class="cloume_div_list_item">{{props.row.Length}}</div>
                </div>
                <div>
                  <div class="cloume_div_list_item">{{props.row.WidthCm}}</div>
                  <div class="cloume_div_list_item">{{props.row.Height}}</div>
                </div>
                <div>
                  <div class="cloume_div_list_item">{{props.row.HeightCm}}</div>
                  <div class="cloume_div_list_item">{{props.row.Width}}</div>
                </div>
                <div>
                  <div class="cloume_div_list_item">{{props.row.volume}}</div>
                  <div class="cloume_div_list_item">{{props.row.FVolume}}</div>
                </div>
              </div>

              <div class="cloume_div_list">
                <div class="cloume_div_list_item cloume_div_list_item_left">分区对比结果</div>
                <div class="cloume_div_list_item">分区</div>
                <div class="cloume_div_list_item">渠道商编号</div>
                <div class="cloume_div_list_item">买家邮编</div>
                <div class="cloume_div_list_item">验证分区</div>
              </div>

              <div class="cloume_div_list">
                <div class="cloume_div_list_item cloume_div_list_item_left"  :class="{abnormalColor:!props.row.isCode}" >{{ props.row.isCode ? "正常" :"存疑"}}</div>
                <div class="cloume_div_list_item">{{props.row.Zone}}</div>
                <div class="cloume_div_list_item">{{props.row.ChannelCode}}</div>
                <div class="cloume_div_list_item">{{props.row.ZipCode}}</div>
                <div class="cloume_div_list_item">{{props.row.Code}}</div>
              </div>
              <div class="cloume_div_list">
                <div class="cloume_div_list_item cloume_div_list_item_left">重量对比结果</div>
                <div class="cloume_div_list_item">收费重量(Kg)</div>
                <div class="cloume_div_list_item">实际重量(Kg)</div>
                <div class="cloume_div_list_item">自有重量(Kg)</div>
              </div>
              <div class="cloume_div_list">
                <div class="cloume_div_list_item cloume_div_list_item_left"  :class="{abnormalColor:!props.row.isWeight}" >{{ props.row.isWeight ? "正常" :"存疑"}}</div>
                <div class="cloume_div_list_item">{{props.row.BillingWeight}}</div>
                <div class="cloume_div_list_item">{{props.row.Weight}}</div>
                <div class="cloume_div_list_item">{{props.row.FWeight}}</div>
              </div>

            </div>
          </template>
        </el-table-column>
        <el-table-column  prop="InstructionNumber" label="尾程单号" width="200" />
        <el-table-column  prop="UpcBarcode" label="物料SKU" width="200" />
        <el-table-column  prop="TotalCost" label="总运费" width="200" />
        <el-table-column  prop="Freight" label="运费" width="100" />
        <el-table-column  prop="OptionCount" label="操作记费数量" width="100" />
        <el-table-column  prop="OptionPrice" label="操作费单价" width="100" />
        <el-table-column  prop="OptionWeight" label="操作实际重量(KG)" width="100" />
        <el-table-column  prop="OptionFee" label="操作费" width="100" />
        <el-table-column  prop="BunringFee" label="燃油费" width="100" />
        <el-table-column  prop="AdressFreight" label="住宅地址费" width="100" />
        <el-table-column  prop="AdressSeasonFreight" label="住宅旺季附加费" width="100" />
        <el-table-column  prop="DasFee" label="偏远地区附加费" width="100" />
        <el-table-column  prop="ChargeFee" label="附加费" width="100" />
        <el-table-column  prop="SeasonChargeFee" label="旺季附加费" width="100" />
        <el-table-column  prop="ProcedLengthFee" label="超长手续附加费" width="100" />
        <el-table-column  prop="ProcedWeigthFee" label="超重手续附加费" width="100" />
        <el-table-column  prop="BigPackageFee" label="大包裹附加费" width="100" />
        <el-table-column  prop="AHSSeasonFreight" label="AHS旺季附加费" width="100" />
        <el-table-column  prop="BigPackageSeasonFee" label="超大件旺季附加费" width="100" />
        <el-table-column  prop="DeclaredValueSurcharge" label="保险附加费" width="100" />
        <el-table-column  prop="SignatureSurcharge" label="签名附加费" width="100" />
        <el-table-column  prop="SaleOderNum" label="销售订单" width="200" />
        <el-table-column  prop="WarehouseCode" label="发货仓名称" width="150" />
        <el-table-column  prop="ChannelCode" label="渠道商编号" width="150" />
        <el-table-column  prop="UserCode" label="客户编号" width="150" />
      </el-table>
      <div class="flex flex-row-center flex-item-center margin-10-0 pagination">
        <el-pagination v-model:current-page="PageNumber"  :page-size="20" @change="changeType(abType)" background layout="prev, pager, next" :total="defaultTotal" />
      </div>

    </div>
  </div>

</template>

<script>
import {ElForm,ElFormItem,ElInput,ElTable,ElTableColumn,ElDatePicker,
  ElPagination,ElButton} from "element-plus";
import {getDeliverOrder} from "@/utils/api"
export default {
  name: 'ContrastData',
  components: {
    ElTable,ElTableColumn,ElPagination,ElButton,
    ElFormItem,ElForm,ElInput,ElDatePicker
  },
  data(){
    return{
      formInline:{
        startMonth: "",
        endMonth: "",
        MaterialNumber:'',
      },
      abType:"ALL",
      tableData:[],
      PageNumber:1,
      defaultTotal:0,
      moneyCount:0.00,
      baseMoney:0.00,
      addMoney:0.00,
      optionMoney:0.00,
      area:0,
      volume:0,
      weight:0,
    }
  },
  computed: {
    timeDefault() {
      var date = new Date(new Date());
      var s1 =
          date.getFullYear() + "-"+
          (date.getMonth() + 1 < 10 ? "0" : "") +
          (date.getMonth() + 1);
      return s1;
    },
    height(){
      return window.innerHeight - 300
    }
  },
  beforeMount (){
    this.formInline.startMonth =  this.timeDefault;
    this.formInline.endMonth =  this.timeDefault;
    this.getDatalist()
  },
  methods: {
    getDatalist(type='ALL'){
      //127.0.0.1
      //192.168.0.22
      getDeliverOrder({...this.formInline,PageNumber:this.PageNumber,PageSize:20,abType:type} ).then((res)=>{
        console.log(res)
        this.area = res.area
        this.volume = res.volume
        this.weight = res.weight
        this.tableData = res.data
        this.defaultTotal = res.Total
        this.moneyCount = res.moneyCount
        this.baseMoney = res.baseMoney
        this.addMoney = res.addMoney
        this.optionMoney = res.optionMoney
      }).catch((err)=>{
        console.log(err)
      })
    },
    changeType(type){
      this.abType = type
      this.getDatalist(type)
    },
    onSubmit(){
      this.PageNumber = 1
      getDeliverOrder({...this.formInline} ).then((res)=>{
        this.area = res.area
        this.volume = res.volume
        this.weight = res.weight
        this.tableData = res.data
        this.defaultTotal = res.Total
        this.moneyCount = res.moneyCount
        this.baseMoney = res.baseMoney
        this.addMoney = res.addMoney
        this.optionMoney = res.optionMoney
      }).catch((err)=>{
        console.log(err)
      })
    },
  },

}
</script>

<style scoped>
.contrastData{
  width:100%;
  height: 100%;
  font-size: 24px;
  padding: 30px 0;
}
.contrastDataForm{
  margin: 20px;

}
.contrastDataTable{
  width: 80%;
  margin: 0 auto;
  padding: 40px 0;
}
.pagination{
  width: fit-content;
  margin: 20px auto;
}
.templateDiv{
  width: 80%;
  margin: 20px 47px;
  margin-top: -9px;
  border-collapse: collapse; /* 合并相邻边框 */
}
.cloume_div_list{
  display: flex;
  justify-content: start;
  align-items: center;
}
.cloume_div_list_item_left{
  border-left: 1px #999999 solid;
}
.cloume_div_list_item_top{
  border-top: 1px #999999 solid;
}
.cloume_div_list_item{
  width: 150px;
  height: 20px;
  text-align: center;
  empty-cells:show;
  border-right: 1px #999999 solid;
  border-bottom: 1px #999999 solid;
  text-align: center;
}
.abnormalColor{
  color: deeppink;
}
.abnormal{
  display: flex;
  margin-left: 10%;
  justify-content: flex-start;
  align-items: center;
  font-size: 18px;
  color: #909399;
}
.abnormals{
  width: 80%;
  display: flex;
  margin:0 auto;
  justify-content:space-between;
  align-items: center;
  font-size: 18px;
  color: #909399;
}
.abnormalitem{
  font-size: 14px;
  font-weight: 600;
}
</style>